
$(document).ready(function() {

	$('.autoselect').click(function() {
		console.log('test');
		$(this).select();
		SelectText($(this));
	});
});